// Simple structured logger for frontend
export const logInfo = (msg, data = {}) => {
  try {
    // eslint-disable-next-line no-console
    
  } catch {}
};

export const logWarn = (msg, data = {}) => {
  try {
    // eslint-disable-next-line no-console
    
  } catch {}
};

export const logError = (msg, err = {}) => {
  try {
    // eslint-disable-next-line no-console
    
  } catch {}
};

export default { logInfo, logWarn, logError };

